import axios from 'axios';

// Funzione per effettuare la richiesta al backend e ottenere le mine
export const fetchMines = async (setMines, setLoading, setError) => {
    try {
        const response = await axios.get('https://adapt-api.softmining.it/mines/me', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        setMines(response.data.data);
    } catch (err) {
        setError(err.response?.data?.message || err.message);
    } finally {
        setLoading(false);
    }
};

// Funzione per eliminare una mine
export const deleteMyMine = async (mineId) => {
    console.log(localStorage.getItem('token'));
    try {
        const response = await axios.delete(
            `https://adapt-api.softmining.it/mines/${mineId}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        alert(`Mine deleted: ${response.data.message}`);
        window.location.reload(); // Ricarica la pagina
    } catch (err) {
        console.error('Errore durante l\'eliminazione della mine:', err.response?.data || err.message);
    }
};

// Funzione per creare una nuova Mine
export const createMine = async (mineName, setMines, mines, setMineName) => {
    try {
        const response = await axios.post(
            'https://adapt-api.softmining.it/mines',
            { name: mineName },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        setMines([...mines, response.data.data]); // Aggiunge la nuova mine alla lista
        setMineName('');
    } catch (err) {
        alert(`Error creating mine: ${err.response?.data?.message || err.message}`);
    }
};

// Funzione per invitare un nuovo utente
export const inviteUser = async (inviteEmail, mines) => {
    if (!inviteEmail) {
        alert('Email is required!');
        return;
    }

    try {
        const selectedMineId = mines._id; // Puoi modificare la logica per selezionare una specifica Mine
        const response = await axios.post(
            `https://adapt-api.softmining.it/mines/${selectedMineId}/invites`,
            { email: inviteEmail },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        alert(`User invited: ${response.data.message}`);
        window.location.reload();
    } catch (err) {
        console.log("Email to invite:", inviteEmail);
        console.log("Mine ID:", mines._id);
        alert(`Error inviting user: ${err.response?.data?.message || err.message}`);
    }
};

// Funzione per rimuovere un utente da una Mine
export const removeUserFromMine = async (userUid, mineId) => {
    try {
        const response = await axios.delete(
            `https://adapt-api.softmining.it/mines/${mineId}/users/${userUid}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        alert(`User removed: ${response.data.message}`);
        window.location.reload();
    } catch (err) {
        alert(`Error removing user: ${err.response?.data?.message || err.message}`);
    }
};

// Funzione per accettare un invito
export const joinMine = async (userId, inviteId) => {
    try {
        const response = await axios.post(
            `https://adapt-api.softmining.it/mines/join`,
            { invite: `${userId}.${inviteId}` },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        alert(`Joined mine: ${response.data.message}`);
        window.location.reload(); // Aggiorna la pagina per riflettere i cambiamenti
    } catch (err) {
        alert(`Error joining mine: ${err.response?.data?.message || err.message}`);
        console.log("Mine ID:", userId);
        console.log("Invite ID:", inviteId);
    }
};

// Funzione per cancellare un invito
export const deleteInvite = async (mineId, inviteId) => {
    try {
        const response = await axios.delete(
            `https://adapt-api.softmining.it/mines/${mineId}/invites/${inviteId}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        alert(`Invite deleted: ${response.data.message}`);
        window.location.reload(); // Aggiorna la pagina per riflettere i cambiamenti
    } catch (err) {
        alert(`Error deleting invite: ${err.response?.data?.message || err.message}`);
    }
};
